import type { LiabilityFeatureConfig } from '../../../types/insurances/LiabilityFeatureConfig';

export const liability: LiabilityFeatureConfig = {
    overview: {
        details: {
            fallbackAssistancePhonesKey: 'CZ',
            fallbackAssistanceEmailsKey: 'CZ',
        },
    },
    history: {
        visible: true,
    },
};
